import Vue from 'vue'
import { mapActions, mapMutations, mapState } from 'vuex'
import gigJobPartiesMixin from './gigJobPartiesMixin'
import statusesMixin from './statusesMixin'
import waitForRefreshApplicationMixin from './waitForRefreshApplicationMixin'
import { getGigOffer } from '@/api/gigs/offers/offers'
import { Blockchain } from '@/constants/blockchain'
import { GigOfferStages } from '@/constants/gig/gigOfferStages'
import snackMixin from '@/mixins/snackMixin'
import GigOfferListItem from '@/models-ts/gigs/GigOfferListItem'
import { RootState } from '@/store'
import { isTronAddress } from '@/utils-ts/tron'

export default Vue.extend({
  mixins: [gigJobPartiesMixin, snackMixin, statusesMixin, waitForRefreshApplicationMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.gigChat.application.value,
      createContractLoading: (state: RootState) => state.gig.createContractLoading,
    }),
    hasStartJob() {
      return this.isEmployer && !this.isStarted && this.application.offer?.stage === GigOfferStages.ACCEPTED_BY_CUSTOMER
    },
    starting() {
      return this.createContractLoading[this.application?.gigId]
    },
  },
  methods: {
    ...mapMutations({
      setCreateContractLoading: 'gig/setCreateContractLoading',
      setDepositingOffer: 'gigChat/setDepositingOffer',
    }),
    ...mapActions({
      signCreateContract: 'gig/signCreateContractV2',
    }),
    async startJob() {
      if (!this.application.offer) return

      try {
        this.setCreateContractLoading({ gigId: this.application.gigId })
        this.setDepositingOffer(this.application.offer.id)

        const offer = GigOfferListItem.fromServer(await getGigOffer(this.application.offer.id)) as any

        const isAllPreferredTron = !offer.preferredCurrencies?.some((currency: any) => currency.blockchain !== Blockchain.Tron)

        if (isTronAddress((offer as any)?.freelancer_wallet) || isAllPreferredTron) {
          this.openModal({
            component: 'lx-composite-modal-new',
            props: {
              title: 'TRON network is no longer supported',
              text: 'Please select a different blockchain to proceed with the contract',
            },
          })
          this.setCreateContractLoading({ gigId: this.application.gigId, loading: false })
          this.setDepositingOffer(null)
          return
        }

        offer.preferredCurrencies = offer.preferredCurrencies.filter((currency: any) => currency.blockchain !== Blockchain.Tron)

        this.signCreateContract({
          gig: offer,
          successSign: async () => {
            this.openSnackbar({
              type: this.SnackTypes.SUCCESS,
              text: 'Your funds have successfully been deposited to escrow.',
            })
            this.setCreateContractLoading({ gigId: this.application.gigId, loading: false })
            await this.waitRefreshApplication()
          },
          cancelSign: () => {
            this.setCreateContractLoading({ gigId: this.application.gigId, loading: false })
            this.setDepositingOffer(null)
          },
        })
      } catch (err) {
        console.error(err)
        this.openSnackbar({
          type: this.SnackTypes.FAILURE,
          text: 'Error starting job',
        })
        this.setCreateContractLoading({ gigId: this.application.gigId, loading: false })
        this.setDepositingOffer(null)
      }
    },
  },
})
